export default {
  SERVER_URL: "https://admin.adsoftware-tech.com/graphql",
  WS_SERVER_URL: "wss://admin.adsoftware-tech.com/graphql"
  //SERVER_URL: "http://localhost:4001/graphql",
  // WS_SERVER_URL: "ws://localhost:4001/graphql"
};
